// Copyright (c) Zammo Inc.

import React from 'react';
import styled from 'styled-components';

import { palette } from '../../styles/variables';

interface TooltipWrapperProps {
  position: string;
}

const TooltipWrapper = styled.div<TooltipWrapperProps>`
  position: absolute;
  z-index: 3;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
  background: white;
  font-family: 'Hind', sans-serif;
  border-radius: 0.25em;
  font-size: 14px;
  font-weight: 400;
  color: ${palette.darkGray};
  padding: 8px 15px;
  line-height: 20px;

  text-align: left;
  min-width: 180px;
  width: fit-content;
  top: -8px;
  visibility: hidden;
  opacity: 0;
  transition: all ease-in-out 0.5s;

  ${(props) =>
    props.position === 'left'
      ? `
    margin-right: 12px;
    right: 100%;
    &:before {
      content: '';
      border-bottom: 8px solid transparent;
      border-left: 10px solid white;
      border-top: 8px solid transparent;
      right: -10px;
      position: absolute;
    }
  `
      : `
    left: 100%;
    margin-left: 12px;
    &:before {
      content: '';
      border-top: 8px solid transparent;
      border-right: 10px solid white;
      border-bottom: 8px solid transparent;
      left: -10px;
      position: absolute;
    }
  `}
`;

const TriggerContainer = styled.div`
  cursor: pointer;
  color: ${palette.mediumBlue};
  top: -4px;
  z-index: 2;

  > svg {
    display: block;
    color: ${palette.gray};
  }
`;

const Container = styled.div`
  position: relative;
  display: inline-block;
  &:hover {
    ${TooltipWrapper} {
      visibility: visible;
      opacity: 1;
      transition: all ease-in-out 0.5s;
    }

    ${TriggerContainer} {
      svg {
        color: ${palette.blue};
      }
    }
  }
`;

type Props = {
  children: React.ReactNode;
  trigger: JSX.Element;
  tooltipPosition?: string;
};

const Tooltip = (props: Props) => (
  <Container>
    <TriggerContainer>
      {props.trigger}
      <TooltipWrapper position={props.tooltipPosition || 'right'}>{props.children}</TooltipWrapper>
    </TriggerContainer>
  </Container>
);

export default Tooltip;
